<template>
  <div class="task-card-container" ml="0.5" mr="0.5" mb="1">
    <div :class="`rounded position-relative task-card`">
      <div class="position-absolute" loading-element v-if="loading">
      </div>
      <vue-admin-tasks-task-error-window :error="error"></vue-admin-tasks-task-error-window>
      <div pl=1 pr=1 pt=0.5 pb=0.5 :class="`d-flex task-card-content task-card-${cardStatus}`">
        <div class="task-header">
          <slot name="header"></slot>
        </div>
        <div class="task-body flex-grow-1" mt=0.5 mb=0.5>
          <slot name="body"></slot>
        </div>
        <div class="task-footer" mb=0.5>
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default{
  props: {
    cardStatus: {
      type: String,
      default: 'new'
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
